<template>
  <div class="shootingScorePK">
    <el-card class="parent-info-card" shadow="hover">
      <div class="shootingScore-type-info">
        <div class="info-row">
          <el-button icon="el-icon-back" @click="$router.back()" >返回</el-button>
          <div class="title-container">
            <span class="info-value">No. {{ shooterNo1 || '000000'}}-{{ shooterName1 || '--'}}</span>
            <span class="pk-title">PK</span>
            <span class="info-value">No. {{ shooterNo2 || '000000'}}-{{ shooterName2 || '--'}}</span>
          </div>
        </div>
      </div>
    </el-card>

    <div class="shooting-page-container">
      <!-- 左侧：1号射手 -->
      <div class="shooter-container">
        <!-- 上方：数据可视化区域 -->
        <div class="visual-area">
          <!-- 靶纸可视化容器 -->
          <div class="target-container">
            <!-- 靶纸背景 -->
            <div class="target-bg" :style="{ backgroundImage: 'url(' + require('@/assets/target-background.jpg') + ')'}"></div>
            <!-- 战区+靶编号（2区2号） -->
            <div class="war-target">
              {{ warZone1 }}区{{ targetNo1 }}号
            </div>
            <!-- 当前环数（0.0环） -->
            <div class="ring-score">
              {{ ringScore1 }} 环
            </div>
            <!-- 散布数据 -->
            <div class="dispersion-group">
              <div class="dispersion">射弹散布</div>
              <div class="dispersion-x">横向  {{ offsetX1 || '0000' }}</div>
              <div class="dispersion-y">纵向  {{ offsetY1 || '0000' }}</div>
            </div>
            <!-- 弹着点（区分当前/历史发） -->
            <div 
              class="hit-point"
              v-for="(point, idx) in hitPointsList1"
              :key="`hit-${idx}`"
              :style="{
                left: `${point.hitX / 50 * 100}%`,
                top: `${point.hitY / 50 * 100}%`,
                backgroundImage: `url(${point.imgSrc})`,
                width: pointSize,
                height: pointSize
              }"
            >
              <span class="shot-seq">{{ point.shotSeq }}</span>
            </div>
          </div>
        </div>
        <!-- 下方：射击成绩区域 -->
        <div class="score-area">
          <!-- 成绩列表（超过10行容器内滚动） -->
          <div class="score-list-container">
            <table class="score-table">
              <thead>
                <tr>
                  <th>发序</th>
                  <th>命中数</th>
                  <th>单枪成绩</th>
                  <th>时间</th>
                </tr>
              </thead>
              <tbody ref="scoreTbody1">
                <tr v-for="(record) in shootingRecords1" :key="record.shotSeq">
                  <td>{{ record.shotSeq }}</td>
                  <td>{{ record.hitShotSeq }}</td>
                  <td>{{ record.ringScore }}</td>
                  <td>{{ record.shotDuration }}</td>
                </tr>
                <!-- 若数据不足10条，补空行（匹配默认10行） -->
                <tr v-for="i in Math.max(10 - shootingRecords1.length, 0)" :key="`empty-${i}`">
                  <td>0</td>
                  <td>0</td>
                  <td>0.0</td>
                  <td>00:00.00</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 总数据区域（固定底部） -->
          <div class="total-data-bar">
            <div class="total-item">总发数</div>
            <div class="total-item">总命中数</div>
            <div class="total-item">总成绩</div>
            <div class="total-item">总用时</div>
          </div>
          <div class="total-data-value">
            <div class="total-value">{{ totalData1.shotSeq }}</div>
            <div class="total-value">{{ totalData1.hitShotSeq }}</div>
            <div class="total-value">{{ totalData1.totalScore }}</div>
            <div class="total-value">{{ totalData1.shotTotalDuration }}</div>
          </div>
        </div>
      </div>
      <!-- 右侧：2号射手 -->
      <div class="shooter-container">
        <!-- 上方：数据可视化区域 -->
        <div class="visual-area">
          <!-- 靶纸可视化容器 -->
          <div class="target-container">
            <!-- 靶纸背景 -->
            <div class="target-bg" :style="{ backgroundImage: 'url(' + require('@/assets/target-background.jpg') + ')'}"></div>
            <!-- 战区+靶编号（2区2号） -->
            <div class="war-target">
              {{ warZone2 }}区{{ targetNo2 }}号
            </div>
            <!-- 当前环数（0.0环） -->
            <div class="ring-score">
              {{ ringScore2 }} 环
            </div>
            <!-- 散布数据 -->
            <div class="dispersion-group">
              <div class="dispersion">射弹散布</div>
              <div class="dispersion-x">横向  {{ offsetX2 || '0000' }}</div>
              <div class="dispersion-y">纵向  {{ offsetY2 || '0000' }}</div>
            </div>
            <!-- 弹着点（区分当前/历史发） -->
            <div 
              class="hit-point"
              v-for="(point, idx) in hitPointsList2"
              :key="`hit-${idx}`"
              :style="{
                left: `${point.hitX / 50 * 100}%`,
                top: `${point.hitY / 50 * 100}%`,
                backgroundImage: `url(${point.imgSrc})`,
                width: pointSize,
                height: pointSize
              }"
            >
              <span class="shot-seq">{{ point.shotSeq }}</span>
            </div>
          </div>
        </div>
        <!-- 下方：射击成绩区域 -->
        <div class="score-area">
          <!-- 成绩列表（超过10行容器内滚动） -->
          <div class="score-list-container">
            <table class="score-table">
              <thead>
                <tr>
                  <th>发序</th>
                  <th>命中数</th>
                  <th>单枪成绩</th>
                  <th>时间</th>
                </tr>
              </thead>
              <tbody ref="scoreTbody2">
                <tr v-for="(record) in shootingRecords2" :key="record.shotSeq">
                  <td>{{ record.shotSeq }}</td>
                  <td>{{ record.hitShotSeq }}</td>
                  <td>{{ record.ringScore }}</td>
                  <td>{{ record.shotDuration }}</td>
                </tr>
                <!-- 若数据不足10条，补空行（匹配默认10行） -->
                <tr v-for="i in Math.max(10 - shootingRecords2.length, 0)" :key="`empty-${i}`">
                  <td>0</td>
                  <td>0</td>
                  <td>0.0</td>
                  <td>00:00.00</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- 总数据区域（固定底部） -->
          <div class="total-data-bar">
            <div class="total-item">总发数</div>
            <div class="total-item">总命中数</div>
            <div class="total-item">总成绩</div>
            <div class="total-item">总用时</div>
          </div>
          <div class="total-data-value">
            <div class="total-value">{{ totalData2.shotSeq }}</div>
            <div class="total-value">{{ totalData2.hitShotSeq }}</div>
            <div class="total-value">{{ totalData2.totalScore }}</div>
            <div class="total-value">{{ totalData2.shotTotalDuration }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import recordApi from '../../api/record';
import SockJS from 'sockjs-client';
import { Stomp } from '@stomp/stompjs';
import config from '../../config/config';

export default {
  name: 'ShootingScorePK',
  data() {
    return {
      // WebSocket通信配置
      imei1: '', // 1号设备的IMEI
      imei2: '', // 2号设备的IMEI
      roundStatus1: '0',// 1号是否射击结束
      roundStatus2: '0',// 2号是否射击结束
      stompClient: null,
      isConnected: false,
      subInstanceMap: {},
      wsEndpoint: config.WebSocketURL + '/ws',
      deviceTopicPrefix: '/topic/shooting-data/',

      // 页面业务数据
      warZone1: '0',
      targetNo1: '0',
      ringScore1: '0.0',
      offsetX1: '0000',
      offsetY1: '0000',
      shooterNo1: '000000', // 射手编号
      shooterName1: '--', // 射手姓名
      hitPointsList1: [], // 弹着点列表：{ hitX, hitY, shotSeq, imgSrc }
      shootingRecords1: [], // 射击成绩列表：{ singleScore, time }
      totalData1: { // 总数据（固定展示）
        shotSeq: '0',
        hitShotSeq: '0',
        totalScore: '0.0',
        shotTotalDuration: '00:00.00'
      },
      stopReceiving1: false, // 1号射手停止接收标志
      tempHistoryRecords1: [],
      tempHistoryHitPoints1: [],

      warZone2: '0',
      targetNo2: '0',
      ringScore2: '0.0',
      offsetX2: '0000',
      offsetY2: '0000',
      shooterNo2: '000000', // 射手编号
      shooterName2: '--', // 射手姓名
      hitPointsList2: [], // 弹着点列表：{ hitX, hitY, shotSeq, imgSrc }
      shootingRecords2: [], // 射击成绩列表：{ singleScore, time }
      totalData2: { // 总数据（固定展示）
        shotSeq: '0',
        hitShotSeq: '0',
        totalScore: '0.0',
        shotTotalDuration: '00:00.00'
      },
      stopReceiving2: false, // 2号射手停止接收标志
      tempHistoryRecords2: [],
      tempHistoryHitPoints2: [],
      
      hitPointImg: require('@/assets/hit-point.png'),
      hitPointLastImg: require('@/assets/hit-point-last.png'),
    };
  },
  computed: {
    // 弹着点尺寸：坐标线间距的3倍距（自适应）
    pointSize() {
      return `${(100 / 50) * 3}%`; 
    },
  },
  mounted() {
    this.imei1 = this.$route.query.imei1;
    this.imei2 = this.$route.query.imei2;
    this.roundStatus1 = this.$route.query.roundStatus1;
    this.roundStatus2 = this.$route.query.roundStatus2;
    this.warZone1 = this.$route.query.target1.warZone;
    this.targetNo1 = this.$route.query.target1.targetNo;
    this.warZone2 = this.$route.query.target2.warZone;
    this.targetNo2 = this.$route.query.target2.targetNo;
    this.initWebSocket(); // 初始化WebSocket连接
  },
  watch: {
    // 监听射击记录数组的变化
    shootingRecords1: {
      handler(newVal) {
        // 仅当数据超过10条时才自动滚动
        if (newVal.length > 10) {
          this.$nextTick(() => {
            // 获取tbody的DOM元素
            const tbody = this.$refs.scoreTbody1;
            if (tbody) {
              // 核心：把滚动高度设为最大，直接滚到底部
              tbody.scrollTop = tbody.scrollHeight;
            }
          });
        }
      },
      deep: true // 深度监听，确保数组内部元素变化也能触发
    },
    shootingRecords2: {
      handler(newVal) {
        // 仅当数据超过10条时才自动滚动
        if (newVal.length > 10) {
          this.$nextTick(() => {
            // 获取tbody的DOM元素
            const tbody = this.$refs.scoreTbody2;
            if (tbody) {
              // 核心：把滚动高度设为最大，直接滚到底部
              tbody.scrollTop = tbody.scrollHeight;
            }
          });
        }
      },
      deep: true // 深度监听，确保数组内部元素变化也能触发
    }
  },
  beforeDestroy() {
    this.unsubscribe(this.imei1);
    this.unsubscribe(this.imei2);
    this.disconnectWebSocket(); // 断开连接
  },
  methods: {
    // 初始化WebSocket（STOMP协议）
    initWebSocket() {
      // 1. 把SockJS包装成工厂函数传入Stomp.over
      this.stompClient = Stomp.over(() => new SockJS(this.wsEndpoint));
      // 2. 配置自动重连（可选，解决警告同时开启重连）
      this.stompClient.configure({
        autoReconnect: true, // 开启自动重连
        reconnectDelay: 5000, // 重连间隔5秒
        debug: () => {} // 关闭调试日志
      });
      this.stompClient.connect({}, 
        () => {
          this.isConnected = true;
          this.subscribeDeviceData(this.imei1, this.roundStatus1);
          this.subscribeDeviceData(this.imei2, this.roundStatus2);
        },
        (err) => {
          this.isConnected = false;
          console.error('WebSocket连接失败：', err);
        }
      );
    },
    // 订阅指定设备的射击数据
    subscribeDeviceData(imei, roundStatus) {
      if (!this.stompClient || !this.isConnected || !imei) return;
      const topic = `${this.deviceTopicPrefix}${imei}`;
      const subInstance = this.stompClient.subscribe(topic, (msg) => {
        this.handleDeviceMessage(imei, msg.body);
      });
      this.subInstanceMap[imei] = subInstance;
      // 根据订阅的imei重新发送进行中的历史报文
      recordApi.pushHistoryShootData(imei, roundStatus).then(res => {
        if (!res.success) {
          this.$message.error(res.message);
        }
      });
    },
    // 处理设备推送的报文
    handleDeviceMessage(imei, content) {
      try {
        const msgObj = JSON.parse(content);
        const { pkgType } = msgObj;
        // 根据IMEI判断是1号还是2号射手，获取对应的数据引用
        const isShooter1 = imei === this.imei1;
        const shooterData = isShooter1 ? this.getShooter1DataRef() : this.getShooter2DataRef();
        // 根据pkgType执行不同逻辑
        switch (pkgType) {
          case '1':
            // 开始处理数据
            shooterData.setStopReceiving(false);
            // 清空所有数据，重新写入射手编号、战区、靶号
            shooterData.setHitPointsList([]);
            shooterData.setShootingRecords([]);
            shooterData.setTotalData({ shotSeq: '0', hitShotSeq: '0', totalScore: '0.0', shotTotalDuration: '00:00.00' });
            shooterData.setShooterNo(String(msgObj.shooterNo || '').padStart(6, '0'));
            shooterData.setShooterName(msgObj.shooterName || '--');
            shooterData.setWarZone(msgObj.warZone || '0');
            shooterData.setTargetNo(msgObj.targetNo || '0');
            shooterData.setRingScore('0.0');
            shooterData.setOffsetX('0000');
            shooterData.setOffsetY('0000');
            // 重置成绩列表滚动条到顶部
            this.$nextTick(() => {
              // 根据 isShooter1 判断当前是哪个射手
              const currentTbody = isShooter1 ? this.$refs.scoreTbody1 : this.$refs.scoreTbody2;
              if (currentTbody) {
                currentTbody.scrollTop = 0;
              }
            });
            break;
          case '2':
            // 停止接收数据
            shooterData.setStopReceiving(true);
            break;
          case '3':
            if (shooterData.stopReceiving) return; // pkgType=2时停止处理
            // 处理弹着点+成绩展示
            this.handleShootingData(shooterData, msgObj);
            break;
          default:
            console.warn('未知pkgType：', pkgType);
        }
      } catch (e) {
        console.error('报文解析失败：', e);
      }
    },
    // 处理pkgType=3的射击数据
    handleShootingData(shooterData, msgObj) {
      // 1. 获取报文原始XY值（未加1）
      const originHitX = Number(msgObj.hitX) || 0;
      const originHitY = Number(msgObj.hitY) || 0;
      const ringScore = Number(msgObj.ringScore) || 0;
      if (msgObj.msgType === 'HISTORY') {
        // 2. 判断不处理的情况：
        // 非XY都为0且原始XY都<50
        if (!((originHitX === 0 && originHitY === 0) || originHitX > 50 || originHitY > 50)) {
          if (ringScore !== 0) {
            // 1. 处理历史弹着点：上一发切换为普通图
            if (shooterData.tempHistoryHitPoints.length > 0) {
              const lastPoint = { ...shooterData.tempHistoryHitPoints.at(-1) };
              lastPoint.imgSrc = this.hitPointImg; // 普通图
              shooterData.tempHistoryHitPoints.splice(shooterData.tempHistoryHitPoints.length - 1, 1, lastPoint);
            }
            // 2. 计算最终弹着点坐标（加1后再做0-50边界兜底）
            const hitX = originHitX + 1;
            const hitY = originHitY + 1;
            // 3. 缓存当前发弹着点（用last图）
            shooterData.tempHistoryHitPoints.push({
              hitX,
              hitY,
              shotSeq: msgObj.shotSeq || '0',
              imgSrc: this.hitPointLastImg // last图
            });
          }
        }
        // 2. 缓存射击成绩列表
        shooterData.tempHistoryRecords.push({
          shotSeq: msgObj.shotSeq || '0',
          hitShotSeq: msgObj.hitShotSeq || '0',
          ringScore: msgObj.ringScore || '0.0',
          offsetX: this.formatFourDigits(msgObj.offsetX) || '0000',
          offsetY:this.formatFourDigits(msgObj.offsetY) || '0000',
          shotDuration: this.formatTimeToMMSSMS(msgObj.shotDuration) || '00:00.00', 
          totalScore: msgObj.totalScore || '0.0',
          shotTotalDuration: this.formatTimeToMMSSMS(msgObj.shotTotalDuration) || '00:00.00',
        });
        // 3. 判断是否接收完所有历史报文（核心：sequence+1 === total）
        const currentSeq = Number(msgObj.sequence);
        const total = Number(msgObj.total);
        if (currentSeq + 1 === total) {
          // 收完所有历史数据：按sequence排序（和后台SQL顺序完全一致）
          shooterData.tempHistoryRecords.sort((a, b) => Number(a.sequence) - Number(b.sequence));
          shooterData.tempHistoryHitPoints.sort((a, b) => Number(a.shotSeq) - Number(b.shotSeq));
          // 替换现有渲染列表（完全覆盖原有数据，避免混乱）
          shooterData.setShootingRecords([...shooterData.tempHistoryRecords]);
          shooterData.setHitPointsList([...shooterData.tempHistoryHitPoints]);
          // 更新总数据（总发数/总成绩/总用时）及靶面数据
          const lastHistoryMsg = shooterData.tempHistoryRecords.at(-1);
          shooterData.ringScore = lastHistoryMsg.ringScore || '0.0';
          shooterData.offsetX = lastHistoryMsg.offsetX || '0000';
          shooterData.offsetY = lastHistoryMsg.offsetY || '0000';
          shooterData.totalData.shotSeq = lastHistoryMsg.shotSeq || '0';
          shooterData.totalData.hitShotSeq = lastHistoryMsg.hitShotSeq || '0';
          shooterData.totalData.totalScore = lastHistoryMsg.totalScore || '0.0';
          shooterData.totalData.shotTotalDuration = lastHistoryMsg.shotTotalDuration || '00:00.00';
          // 清空临时缓存
          shooterData.tempHistoryRecords = [];
          shooterData.tempHistoryHitPoints = [];
        }
      }  else if (msgObj.msgType === 'REAL_TIME') {
        // 2. 判断不处理的情况：
        // 非XY都为0且原始XY都<50
        if (!((originHitX === 0 && originHitY === 0) || originHitX > 50 || originHitY > 50)) {
          if (ringScore !== 0) {
            // 1. 处理历史弹着点：上一发切换为普通图
            if (shooterData.hitPointsList.length > 0) {
              const lastPoint = { ...shooterData.hitPointsList.at(-1) };
              lastPoint.imgSrc = this.hitPointImg; // 普通图
              shooterData.hitPointsList.splice(shooterData.hitPointsList.length - 1, 1, lastPoint);
            }
            // 2. 计算最终弹着点坐标（加1后再做0-50边界兜底）
            const hitX = originHitX + 1;
            const hitY = originHitY + 1;
            // 3. 添加当前发弹着点（用last图）
            shooterData.hitPointsList.push({
              hitX,
              hitY,
              shotSeq: msgObj.shotSeq || '0',
              imgSrc: this.hitPointLastImg // last图
            });
          }
        }
        // 2. 处理射击成绩列表及靶面信息
        shooterData.ringScore = msgObj.ringScore || '0.0';
        shooterData.offsetX = this.formatFourDigits(msgObj.offsetX) || '0000';
        shooterData.offsetY = this.formatFourDigits(msgObj.offsetY) || '0000';
        shooterData.shootingRecords.push({
          shotSeq: msgObj.shotSeq || '0',
          hitShotSeq: msgObj.hitShotSeq || '0',
          ringScore: msgObj.ringScore || '0.0',
          shotDuration: this.formatTimeToMMSSMS(msgObj.shotDuration) || '00:00.00', 
        });
        // 3. 更新总数据（总发数/总成绩/总用时）
        shooterData.totalData.shotSeq = msgObj.shotSeq || '0';
        shooterData.totalData.hitShotSeq = msgObj.hitShotSeq || '0';
        shooterData.totalData.totalScore = msgObj.totalScore || '0.0';
        shooterData.totalData.shotTotalDuration = this.formatTimeToMMSSMS(msgObj.shotTotalDuration) || '00:00.00';
        shooterData.shootingRecords.sort((a, b) => Number(a.shotSeq) - Number(b.shotSeq));
        shooterData.hitPointsList.sort((a, b) => Number(a.shotSeq) - Number(b.shotSeq));
      }
    },
    getShooter1DataRef() {
      return {
        prefix: '1',
        warZone: this.warZone1,
        targetNo: this.targetNo1,
        ringScore: this.ringScore1,
        offsetX: this.offsetX1,
        offsetY: this.offsetY1,
        shooterNo: this.shooterNo1,
        shooterName: this.shooterName1,
        hitPointsList: this.hitPointsList1,
        shootingRecords: this.shootingRecords1,
        totalData: this.totalData1,
        stopReceiving: this.stopReceiving1,
        tempHistoryRecords: this.tempHistoryRecords1,
        tempHistoryHitPoints: this.tempHistoryHitPoints1,
        // 用于直接修改this上的属性
        setWarZone: (val) => { this.warZone1 = val; },
        setTargetNo: (val) => { this.targetNo1 = val; },
        setRingScore: (val) => { this.ringScore1 = val; },
        setOffsetX: (val) => { this.offsetX1 = val; },
        setOffsetY: (val) => { this.offsetY1 = val; },
        setShooterNo: (val) => { this.shooterNo1 = val; },
        setShooterName: (val) => { this.shooterName1 = val; },
        setStopReceiving: (val) => { this.stopReceiving1 = val; },
        setHitPointsList: (val) => { this.hitPointsList1 = val; },
        setShootingRecords: (val) => { this.shootingRecords1 = val; },
        setTotalData: (val) => { this.totalData1 = val; },
        setTempHistoryRecords: (val) => { this.tempHistoryRecords1 = val; },
        setTempHistoryHitPoints: (val) => { this.tempHistoryHitPoints1 = val; }
      };
    },
    getShooter2DataRef() {
      return {
        prefix: '2',
        warZone: this.warZone2,
        targetNo: this.targetNo2,
        ringScore: this.ringScore2,
        offsetX: this.offsetX2,
        offsetY: this.offsetY2,
        shooterNo: this.shooterNo2,
        shooterName: this.shooterName2,
        hitPointsList: this.hitPointsList2,
        shootingRecords: this.shootingRecords2,
        totalData: this.totalData2,
        stopReceiving: this.stopReceiving2,
        tempHistoryRecords: this.tempHistoryRecords2,
        tempHistoryHitPoints: this.tempHistoryHitPoints2,
        // 用于直接修改this上的属性
        setWarZone: (val) => { this.warZone2 = val; },
        setTargetNo: (val) => { this.targetNo2 = val; },
        setRingScore: (val) => { this.ringScore2 = val; },
        setOffsetX: (val) => { this.offsetX2 = val; },
        setOffsetY: (val) => { this.offsetY2 = val; },
        setShooterNo: (val) => { this.shooterNo2 = val; },
        setShooterName: (val) => { this.shooterName2 = val; },
        setStopReceiving: (val) => { this.stopReceiving2 = val; },
        setHitPointsList: (val) => { this.hitPointsList2 = val; },
        setShootingRecords: (val) => { this.shootingRecords2 = val; },
        setTotalData: (val) => { this.totalData2 = val; },
        setTempHistoryRecords: (val) => { this.tempHistoryRecords2 = val; },
        setTempHistoryHitPoints: (val) => { this.tempHistoryHitPoints2 = val; }
      };
    },
    // 取消指定设备订阅
    unsubscribe(imei) {
      if (this.subInstanceMap[imei]) {
        this.subInstanceMap[imei].unsubscribe();
        delete this.subInstanceMap[imei];
      }
    },
    // 断开WebSocket连接
    disconnectWebSocket() {
      if (this.stompClient?.connected) {
        this.stompClient.disconnect();
      }
      this.isConnected = false;
    },
    // 格式化函数 - 不足四位前面补零，固定四位
    formatFourDigits(value) {
      // 先转成字符串，去除空值/非数字情况，默认值为'0'
      const str = (value || '0').toString();
      // padStart(4, '0')：不足4位时，在开头补0，直到长度为4
      return str.padStart(4, '0');
    },
    // 数字时间格式化为00:00.00
    formatTimeToMMSSMS(timeValue) {
      // 处理空值/非数字，默认0
      const timeNum = Number(timeValue) || 0;
      // 拆分：分钟 = 总秒数÷60；秒 = 总秒数%60；毫秒 = 小数部分×100（保留两位）
      const minutes = Math.floor(timeNum / 60);
      const seconds = Math.floor(timeNum % 60);
      const milliseconds = Math.round((timeNum - Math.floor(timeNum)) * 100);
      // 补零为两位字符串
      const fmtMin = String(minutes).padStart(2, '0');
      const fmtSec = String(seconds).padStart(2, '0');
      const fmtMs = String(milliseconds).padStart(2, '0');
      // 拼接成00:00.00格式
      return `${fmtMin}:${fmtSec}.${fmtMs}`;
    }
  }
};
</script>

<style scoped>
.shootingScorePK {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 占满整个视口高度 */
  overflow: hidden;
}
.parent-info-card {
  width: 100%;
  margin-bottom: 20px;
  border-left: 3px solid #409EFF;
  /* 保持标识性边框 */
  box-sizing: border-box;
  padding: 0 10px;
}
.shootingScore-type-info {
  font-size: 4vh;
  font-weight: bold;
}
.info-row {
  display: flex;
  align-items: center; /* 上下居中 */
  width: 100%;
}
.title-container {
  flex: 1;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 30px;
}
.pk-title {
  color: #F56C6C;
  font-size: 5vh;
}
/* 靶面容器：适配PC端不同显示器 */
.shooting-page-container {
  display: flex;
  width: 100%;
  flex: 1;
  box-sizing: border-box;
  overflow: hidden;
  align-items: stretch;
  padding: 0 10px; /* 可选：添加左右内边距，避免卡片贴边 */
}
/* 射手容器：左右各占50% */
.shooter-container {
  flex: 0 0 50%;
  height: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
}
/* 上侧可视化区域：保持正方形适配 */
.visual-area {
  flex: 0 0 60%;
  width: 100%;
  display: flex;
  align-items: center; /* 靶纸垂直居中 */
  justify-content: center; /* 靶纸水平居中 */
  box-sizing: border-box;
}
/* 靶纸容器 */
.target-container {
  position: relative;
  height: 100%;
  aspect-ratio: 1/1;
  background-color: #fff;
  border: 1px solid #000;
  box-sizing: border-box;
  overflow: hidden;
}
/* 靶纸背景图 */
.target-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  z-index: 0;
}
/* 战区+靶编号 */
.war-target {
  position: absolute;
  top: 5%;
  left: 5%;
  font-size: 3vh;
  font-weight: bold;
  color: #000;
  z-index: 10;
}
/* 当前环数 */
.ring-score {
  position: absolute;
  top: 3%;
  right: 1%;
  font-size: 4vh;
  font-weight: bold;
  color: #000;
  z-index: 10;
}
/* 散布数据 */
.dispersion-group {
  position: absolute;
  top: 15%;
  left: 5%;
  text-align: center;
  z-index: 10;
}
.dispersion, .dispersion-x, .dispersion-y {
  font-size: 2vh;
  font-weight: bold;
  color: #000;
}
/* 弹着点样式（居中对齐坐标） */
.hit-point {
  position: absolute;
  background-size: 100% 100%;
  transform: translate(-50%, -50%);
}
.shot-seq {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #fff;
  font-weight: 700;
  font-size: 100%;
}
/* 下侧成绩区域：拉长至底部 */
.score-area {
  flex: 0 0 40%;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  border: 1px solid #000;
}
/* 成绩列表容器：超过10行滚动 */
.score-list-container {
  height: calc(100% * 10 / 12);
  font-size: 2vh;
  box-sizing: border-box;
  overflow: hidden;
}
/* 成绩表格样式 */
.score-table {
  width: 100%;
  height: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  text-align: center;
  border: none;
}
.score-table thead{
  display: table;
  width: 100%;
  table-layout: fixed;
  height: calc(100% / 11);
}
.score-table tbody{
  display: block;
  width: 100%;
  height: calc(100% * 10 / 11);
  overflow-y: overlay;
  overflow-x: hidden;
}
.score-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
  height: 10%;
  box-sizing: border-box;
}
.score-table th {
  background-color: #274b25;
  color: #fff;
  font-weight: bold;
  border: 1px solid #000;
  width: 25%;
  height: 100%;
}
.score-table td {
  background-color: #fff;
  color: #000;
  border: 1px solid #000;
  width: 25%;
  height: 100%;
  overflow: hidden;
  white-space: nowrap;
}
/* 总数据栏：标题行（深绿背景+白字） */
.total-data-bar {
  display: flex;
  height: calc(100% / 12);
  font-size: 2vh;
  background-color: #274b25;
  color: #fff;
  font-weight: bold;
  border-bottom: none;
}
.total-data-bar .total-item {
  display: flex;
  flex: 1;
  height: 100%;
  text-align: center;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
}
/* 总数据栏：数值行（浅紫背景+黑字） */
.total-data-value {
  display: flex;
  height: calc(100% / 12);
  font-size: 2vh;
  background-color: #fff;
}
.total-data-value .total-value {
  display: flex;
  flex: 1;
  height: 100%;
  text-align: center;
  border: 1px solid #000;
  align-items: center;
  justify-content: center;
}
</style>